import React, {useCallback, useEffect, useState} from "react";
import {Badge, Button, Card, Col, Container, Row, Table} from "react-bootstrap";
import {Link} from "react-router-dom";
import {ToastContainer} from 'react-toastify';
import {useDispatch, useSelector} from "react-redux";
import {deleteProduct as onDeleteProduct} from "../../../slices/product/thunk";
import {getProductData as onGetProductData} from "slices/thunk";
import SearchData from "./SearchData";
import BreadCrumb from "Common/BreadCrumb";
import {DeleteModal} from "Common/DeleteModal";
import {useNavigate, useLocation} from "react-router-dom";
import Pagination from "Common/Pagination";

const url = process.env.REACT_APP_API_URL;
const useQuery = () => new URLSearchParams(useLocation().search);

const Products = () => {
    document.title = "Product MuhlatSavdo";
    const dispatch = useDispatch<any>();
    const navigate = useNavigate();
    const query = useQuery();
    const location = useLocation();

    const pageParam = query.get("page");
    const pageFromUrl = pageParam ? parseInt(pageParam) : 1;
    const [pagination, setPagination] = useState<number>(pageFromUrl);
    const size = 10;

    const [productTable, setProductTable] = useState<any>([]);
    const [show, setShow] = useState<boolean>(false);

    const [searchData, setSearchData] = useState({
        name: "",
        categoryId: null,
        brandId: null,
        colorId: null,
        minPrice: null,
        maxPrice: null,
        isActive: true
    });
    const [delet, setDelet] = useState<any>('');

    const products = useSelector((state: any) => state.Product.productList.content);
    const totalPages = useSelector((state: any) => state.Product.productList.page?.totalPages);
    const totalElements = useSelector((state: any) => state.Product.productList.page?.totalElements);

    useEffect(() => {
        if (searchData.name.length || searchData.colorId || searchData.categoryId || searchData.brandId) {
            setPagination(1);
        }
    }, [searchData]);

    useEffect(() => {
        const pageData = {page: pagination-1, size: size}
        console.log(searchData)
        dispatch(onGetProductData({searchData: searchData, pagination: pageData}));
    }, [dispatch, searchData, pagination]);

    //delete modal state
    const handleCloseDelete = () => setShow(!show);

    const handleDeleteShow = useCallback((product: any) => {
        setDelet(product);
        setShow(!show);
    }, [show]);

    //delete modal
    const deleteModalFunction = () => {
        dispatch(onDeleteProduct(delet.id));
        handleCloseDelete();
    };

    useEffect(() => {
        setProductTable(products);
    }, [products]);

    useEffect(() => {
        const params = new URLSearchParams(location.search);
        params.set("page", pagination.toString());
        navigate({search: params.toString()}, {replace: true});
    }, [pagination, navigate, location.search]);

    return (
        <React.Fragment>
            <div className="page-content">
                <Container fluid>
                    <BreadCrumb title="Product" pageTitle="Products"/>
                    <div id="productList">
                        <SearchData setSearchData={setSearchData}/>
                        <Row>
                            <Col lg={12}>
                                <Card>
                                    <Card.Header className=" d-flex align-items-center">
                                        <div className="flex-grow-1">
                                            <Card.Title as="h5" className="mb-0">
                                                Products
                                                <Badge bg="dark-subtle" text="dark"
                                                       className="ms-1">{totalElements}</Badge>
                                            </Card.Title>
                                        </div>
                                        <div className="flex-shrink-0">
                                            <div className="d-flex flex-wrap align-items-start gap-2">
                                                <button className="btn btn-subtle-danger d-none" id="remove-actions">
                                                    <i className="ri-delete-bin-2-line"></i>
                                                </button>
                                                <Link to={"/create-product"}>
                                                    <Button type="button" variant="primary" className="add-btn">
                                                        <i className="bi bi-plus-circle align-baseline me-1"></i> Add
                                                        Product
                                                    </Button>
                                                </Link>
                                            </div>
                                        </div>
                                    </Card.Header>
                                    <Card.Body className="mt-4">
                                        {
                                            productTable && productTable.length > 0 ? (
                                                <div className={"table-responsive table-card"}>
                                                    <Table hover
                                                           className={"table table-centered align-middle table-custom-effect table-nowrap mb-0"}
                                                           bordered={false}>
                                                        <thead className={"table-light"}>
                                                        <tr>
                                                            <th className={"cursor-pointer select-none"}>№</th>
                                                            <th className={"cursor-pointer select-none"}>Products</th>
                                                            <th className={"cursor-pointer select-none "}>Category</th>
                                                            <th className={"cursor-pointer select-none "}>Brand</th>
                                                            <th className={"cursor-pointer select-none "}>Color</th>
                                                            <th className={"cursor-pointer select-none "}>Currency</th>
                                                            <th className={"cursor-pointer select-none "}>Price</th>
                                                            <th className={"cursor-pointer select-none "}>Count</th>
                                                            <th className={"cursor-pointer select-none "}>Create At</th>
                                                            <th className={"cursor-pointer select-none "}>Updated At
                                                            </th>
                                                            <th className={"cursor-pointer select-none "}>Action</th>
                                                        </tr>
                                                        </thead>
                                                        <tbody>
                                                        {
                                                            productTable.map((item: any, index: number) => (
                                                                <tr key={index}>
                                                                    <td><b>{size * (pagination - 1) + index + 1})</b>
                                                                    </td>
                                                                    <td>
                                                                        <div className="d-flex align-items-center">
                                                                            <div
                                                                                className="avatar-md bg-light rounded p-1 me-2">
                                                                                <img src={url + item.images[0]?.url}
                                                                                     alt={item.images[0]?.name}
                                                                                     className="img-fluid d-block product-img"/>
                                                                            </div>
                                                                            <div>
                                                                                <h6 className="mb-0">
                                                                                    <Link
                                                                                        to={`/product-details?id=${item.id}`}
                                                                                        className="text-reset text-capitalize product-title">
                                                                                        {item.name.length > 50
                                                                                            ? `${item.name.slice(0, 50)}...`
                                                                                            : item.name}
                                                                                    </Link>
                                                                                </h6>
                                                                            </div>
                                                                        </div>
                                                                    </td>
                                                                    <td>
                                                                        <div>
                                                                            <p className="mb-0">
                                                                                {item?.categoryDto.name ? (item.categoryDto.name.length > 30 ? `${item.categoryDto.name.slice(0, 30)}...` : item.categoryDto.name) : ""}
                                                                            </p>
                                                                        </div>
                                                                    </td>
                                                                    <td>
                                                                        <div>
                                                                            <p className="mb-0">
                                                                                {item?.brandDto.name ? (item.brandDto.name.length > 30 ? `${item.brandDto.name.slice(0, 30)}...` : item.brandDto.name) : ""}
                                                                            </p>
                                                                        </div>
                                                                    </td>
                                                                    <td>
                                                                        <div>
                                                                            <p className="mb-0">
                                                                                {item?.color?.name ? (item.color?.name.length > 30 ? `${item.color?.name.slice(0, 30)}...` : item.color?.name) : ""}
                                                                            </p>
                                                                        </div>
                                                                    </td>
                                                                    <td>{item.currency}</td>
                                                                    <td>{item.basePrice}</td>
                                                                    <td>{item.quantity}</td>
                                                                    <td>{item.createdAt}</td>
                                                                    <td>{item.updatedAt}</td>
                                                                    <td>
                                                                        <ul className="d-flex gap-2 list-unstyled mb-0">
                                                                            <li>
                                                                                <Link
                                                                                    className={"btn btn-subtle-primary btn-icon btn-sm"}
                                                                                    to={`/product-details?id=${item.id}`}
                                                                                >
                                                                                    <i className="ph-eye"></i>
                                                                                </Link>
                                                                            </li>
                                                                            <li>
                                                                                <Link
                                                                                    to={`/create-product?id=${item.id}`}
                                                                                    className="btn btn-subtle-secondary btn-icon btn-sm edit-item-btn"
                                                                                >
                                                                                    <i className="ph-pencil"></i>
                                                                                </Link>
                                                                            </li>
                                                                            <li className={""}>
                                                                                <Link
                                                                                    to="#"
                                                                                    className="btn btn-subtle-danger btn-icon btn-sm remove-item-btn"
                                                                                    onClick={() => handleDeleteShow(item)}
                                                                                >
                                                                                    <i className="ph-trash"></i>
                                                                                </Link>
                                                                            </li>
                                                                        </ul>
                                                                    </td>
                                                                </tr>
                                                            ))
                                                        }
                                                        </tbody>
                                                    </Table>
                                                </div>
                                            ) : (
                                                <div id="noresult">
                                                    <div className="text-center py-4">
                                                        <div className="avatar-md mx-auto mb-4">
                                                            <div
                                                                className="avatar-title bg-primary-subtle text-primary rounded-circle fs-5xl">
                                                                <i className="bi bi-search"></i>
                                                            </div>
                                                        </div>
                                                        <h5 className="mt-2">Sorry! No Result Found</h5>
                                                    </div>
                                                </div>
                                            )
                                        }
                                        <div className={"d-flex justify-content-end"}>
                                            <Pagination
                                                currentPage={pagination}
                                                totalPages={totalPages}
                                                onPageChange={(page: number) => setPagination(page)}
                                            />
                                        </div>
                                    </Card.Body>
                                </Card>
                            </Col>
                        </Row>
                    </div>
                </Container>
            </div>

            <DeleteModal show={show} handleClose={handleDeleteShow} deleteModalFunction={deleteModalFunction}/>
            <ToastContainer/>
        </React.Fragment>
    );
};

export default Products;